import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { BuyApartmentFlowPaths } from '../../routes';
import useBoundStore from '../../store';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import Switchbox from '../../components/switchbox';
import { RadioButton } from '../../components/radio-button2';
import styles from './styles.module.scss';

enum SortField {
  Price = 'Price',
  Area = 'Area',
}

enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

const BuyApartmentSortSecondary: React.FC = () => {
  const navigate = useNavigate();
  const [prevFieldGlobalState, setPrevFieldGlobalState] = useState<string | undefined>(undefined);
  const [prevDirectionGlobalState, setPrevDirectionGlobalState] = useState<string | undefined>(
    undefined,
  );

  const setFieldGlobalState = useBoundStore((s) => s.setFieldSort);
  const setDirectionGlobalState = useBoundStore((s) => s.setDirectionSort);

  const fieldGlobalState = useBoundStore((s) => s.fieldSort);
  const directionGlobalState = useBoundStore((s) => s.directionSort);

  useEffect(() => {
    setPrevFieldGlobalState(fieldGlobalState);
    setPrevDirectionGlobalState(directionGlobalState);
  }, []);

  const handleBackPage = () => {
    setFieldGlobalState(prevFieldGlobalState);
    setDirectionGlobalState(prevDirectionGlobalState);
    navigate(-1);
  };

  const buttons: ButtonProps[] = [
    {
      label: 'Выбрать',
      variant: 'default',
      onClick: () => {
        navigate(BuyApartmentFlowPaths.apartmentListBuySecondary);
      },
    },
    {
      label: 'Отмена',
      variant: 'gray',
      onClick: handleBackPage,
    },
  ];

  const getSwitchboxProps = (label: string) => ({
    label,
    className: clsx(styles.onlyAvailable),
  });

  return (
    <BaseScreen
      padContent
      title='Сортировка вторички'
      buttons={buttons}
      footerClassName={styles.footer}
      floatingButtons={false}
      onBackButtonClick={handleBackPage}
    >
      <div className={styles.container}>
        <div className={styles.wrapperRadioButtons}>
          <RadioButton
            label={'Стоимость ↑↓'}
            className={clsx(styles.checkbox)}
            checked={fieldGlobalState === SortField.Price}
            onChange={() => {
              setFieldGlobalState(SortField.Price);
              setDirectionGlobalState(undefined);
            }}
          />
          <RadioButton
            label={'Площадь ↑↓'}
            className={clsx(styles.checkbox)}
            checked={fieldGlobalState === SortField.Area}
            onChange={() => {
              setFieldGlobalState(SortField.Area);
              setDirectionGlobalState(undefined);
            }}
          />
        </div>

        {fieldGlobalState === SortField.Price ? (
          <>
            <Switchbox
              {...getSwitchboxProps('Стоимость ↑')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Asc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Asc ? SortDirection.Asc : undefined,
                );
              }}
            />
            <Switchbox
              {...getSwitchboxProps('Стоимость ↓')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Desc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Desc ? SortDirection.Desc : undefined,
                );
              }}
            />
          </>
        ) : (
          <>
            <div className={styles.switchBox}>
            <Switchbox
              {...getSwitchboxProps('Площадь ↑')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Asc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Asc ? SortDirection.Asc : undefined,
                );
              }}
              className={styles.switchBox}
            />
            </div>
            <Switchbox
              {...getSwitchboxProps('Площадь ↓')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Desc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Desc ? SortDirection.Desc : undefined,
                );
              }}
            />
          </>
        )}
      </div>
    </BaseScreen>
  );
};

export default BuyApartmentSortSecondary;
